import { render, staticRenderFns } from "./LearnersCohort.vue?vue&type=template&id=0857e818"
import script from "./LearnersCohort.vue?vue&type=script&lang=js"
export * from "./LearnersCohort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports